import { render } from "./detailNotify.vue?vue&type=template&id=7cd9c1fb&scoped=true"
import script from "./detailNotify.vue?vue&type=script&lang=js"
export * from "./detailNotify.vue?vue&type=script&lang=js"

import "./detailNotify.vue?vue&type=style&index=0&id=7cd9c1fb&lang=scss&scoped=true"
import "./detailNotify.vue?vue&type=style&index=1&id=7cd9c1fb&lang=scss"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd9c1fb"]])

export default __exports__